import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
}), ___EmotionJSX("circle", {
  cx: "9",
  cy: "7",
  r: "4"
}), ___EmotionJSX("path", {
  d: "M23 21v-2a4 4 0 0 0-3-3.87"
}), ___EmotionJSX("path", {
  d: "M16 3.13a4 4 0 0 1 0 7.75"
}));
export default SVG;